import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { NAMESPACES } from '~/i18n/namespaces';
import HBText from '@honeybook/hbui/dist/components/HBText/HBText';
import HBMediaElement from '@honeybook/hbui/dist/components/HBMediaElement/HBMediaElement';
import { useWindowSize } from '@honeybook/hbui/dist/components/common/useWindowSize';

export const SignupPagePrismmContent = () => {
    const { isLargeUp } = useWindowSize();
    const { t } = useTranslation(NAMESPACES.SIGNUP, {
        keyPrefix: 'prismm'
    });

    return isLargeUp ? (
        <TextWrapper>
            <Title type="display48">
                {/*@ts-ignore*/}
                <Trans t={t} i18nKey="title">
                    <HBText type="display48" color="purple500" />
                </Trans>
            </Title>

            <HBText type="body16">{t('description')}</HBText>

            <PrismmIllustration
                width={262}
                height={90}
                path="illustrations/prismm-signup-illustration.png"
                alt="Prismm and Honeybook illustration"
            />
        </TextWrapper>
    ) : (
        <></>
    );
};

export const PrismmCustomMobileLogo = () => (
    <HBMediaElement
        width={93}
        height={32}
        path="illustrations/prismm-signup-illustration.png"
        alt="Prismm and Honeybook illustration"
    />
);

// -------------------------------- Styles -------------------------------- //

const Title = styled(HBText)`
    line-height: 60px;
    margin: 10px 0 20px;
`;

const PrismmIllustration = styled(HBMediaElement)`
    margin-top: 40px;
`;

const TextWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    max-width: 460px;
`;
